import React from 'react';
import classNames from 'classnames';

import SeeMoreButton from '../SeeMoreButton';
import SearchEventCard from '../SearchEventCard';

import { GA_VIEW_MORE_ACTION } from '../../constants';

const getCards = ({
    isSmallCity,
    cards,
    onSaveEvent,
    shareOptions,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    userCollections,
    onAddOrRemoveEventToCollection,
    onCreateCollection,
    followCountVariant,
}) => {
    const cardsArrayLength = cards.length;
    return cards.map(({ id, ...cardProps }, index) => {
        const shouldTrimOddCard =
            cardsArrayLength % 2 === 1 &&
            index === cardsArrayLength - 1 &&
            !isSmallCity;
        const classes = classNames(
            'eds-g-cell',
            'eds-g-cell--has-overflow',
            'eds-g-cell-md-4-12',
            'eds-g-cell-sm-6-12',
            'eds-g-cell-1-1',
            {
                //hide extraneous cards
                'eds-show-up-sm': index > 2 && !isSmallCity,
                //trim odd card so doesnt look wierd on medium breakpoints
                'eds-hide-sm eds-hide-sw eds-hide-mn': shouldTrimOddCard,
            },
        );

        return (
            <div className={classes} key={id}>
                <SearchEventCard
                    id={id}
                    onSaveEvent={onSaveEvent}
                    shareOptions={shareOptions}
                    isAuthenticated={isAuthenticated}
                    trackClick={onTrackClick.bind(null, { id })}
                    trackClickInternal={onTrackClickInternal.bind(null, index)}
                    trackGAEvent={trackGAEvent}
                    experiments={experiments}
                    featureFlags={featureFlags}
                    userCollections={userCollections}
                    onAddOrRemoveEventToCollection={
                        onAddOrRemoveEventToCollection
                    }
                    onCreateCollection={onCreateCollection}
                    followCountVariant={followCountVariant}
                    {...cardProps}
                />
            </div>
        );
    });
};

const BigEventCardGroup = ({
    cards,
    linkUrl,
    onSaveEvent,
    shareOptions,
    isAuthenticated,
    onTrackClick,
    isSmallCity,
    title,
    onTrackClickInternal,
    trackGAEvent,
    experiments,
    featureFlags,
    userCollections,
    onAddOrRemoveEventToCollection,
    onCreateCollection,
    followCountVariant,
}) => (
    <div className="eds-g-group">
        {getCards({
            isSmallCity,
            cards,
            onSaveEvent,
            shareOptions,
            isAuthenticated,
            onTrackClick,
            onTrackClickInternal,
            trackGAEvent,
            experiments,
            featureFlags,
            userCollections,
            onAddOrRemoveEventToCollection,
            onCreateCollection,
            followCountVariant,
        })}
        <div className="eds-show-down-sn eds-align--center">
            <div className="eds-g-cell">
                <SeeMoreButton
                    linkUrl={linkUrl}
                    trackClick={onTrackClick}
                    title={title}
                    gaAction={GA_VIEW_MORE_ACTION}
                />
            </div>
        </div>
    </div>
);

export default BigEventCardGroup;
